var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBeenhereCircle40Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.9543 8.9543 0 20 0V0C31.0457 0 40 8.9543 40 20V20C40 31.0457 31.0457 40 20 40V40C8.9543 40 0 31.0457 0 20V20Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9H13C11.9 9 11.01 9.9 11.01 11L11 23.93C11 24.62 11.35 25.23 11.88 25.59L20 31L28.11 25.59C28.64 25.23 28.99 24.62 28.99 23.93L29 11C29 9.9 28.1 9 27 9ZM20 28.6L13 23.94V11H27V23.93L20 28.6ZM17.99 21.18L15.41 18.59L14 20L18 24L26 16L24.58 14.58L17.99 21.18Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBeenhereCircle40Px);
export default __webpack_public_path__ + "static/media/ic_beenhere_circle-40px.e9b638f0152b5c71592b33291e829858.svg";
export { ForwardRef as ReactComponent };